import {fetchCAPI} from '../utils/fetch-capi'
import {useCAPIQuery} from './useCAPIQuery'

interface SubAgent {
  name: string
}

export function useSubAgents({
  apiURL,
  owner,
  repo,
}: {
  apiURL?: string | null
  owner: string | null
  repo: string | null
}) {
  const query = useCAPIQuery<SubAgent[]>({
    queryKey: ['subagents', owner, repo],
    queryFn: async () => {
      try {
        const response = await fetchCAPI({
          apiURL,
          path: `/agents/swe/internal/subagents/${owner}/${repo}`,
        })

        if (response.status === 404) {
          return []
        }

        const data = await response.json()
        const agents = data.agents as SubAgent[]

        return agents
      } catch {
        return []
      }
    },
    enabled: Boolean(owner && repo), // Only run query when both owner and repo are non-empty
  })

  return {
    ...query,
  }
}
